(function () {
  'use strict';

  document.documentElement.classList.add('js');

  var doc = document;
  var SAMATRIP = window.SAMATRIP || {};
  SAMATRIP.routes = SAMATRIP.routes || {};
  SAMATRIP.currency = SAMATRIP.currency || 'EUR';

  function qs(selector, ctx) {
    return (ctx || doc).querySelector(selector);
  }

  function qsa(selector, ctx) {
    return Array.prototype.slice.call((ctx || doc).querySelectorAll(selector));
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: SAMATRIP.currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function fetchJSON(url, options) {
    options = options || {};
    options.headers = options.headers || {};
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          var err = new Error((data && data.description) || 'Erreur');
          err.data = data;
          throw err;
        });
      }
      return response.json();
    });
  }

  /* ------------------------------------------------------------------
     Sticky header
  ------------------------------------------------------------------ */
  var navbar = qs('[data-navbar]');
  if (navbar) {
    var onScroll = function () {
      navbar.classList.toggle('is-sticky', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ------------------------------------------------------------------
     Mobile menu (details) + search overlay (details)
  ------------------------------------------------------------------ */
  var mobileMenu = qs('[data-mobile-menu]');
  if (mobileMenu) {
    var closeMobile = function () {
      mobileMenu.removeAttribute('open');
    };
    var mobileCloseBtn = qs('[data-mobile-close]', mobileMenu);
    var mobileBackdrop = qs('[data-mobile-backdrop]', mobileMenu);
    if (mobileCloseBtn) {
      mobileCloseBtn.addEventListener('click', closeMobile);
    }
    if (mobileBackdrop) {
      mobileBackdrop.addEventListener('click', closeMobile);
    }
  }

  var searchToggle = qs('[data-search-toggle]');
  if (searchToggle) {
    var closeSearch = function () {
      searchToggle.removeAttribute('open');
    };
    var searchCloseBtn = qs('[data-search-close]');
    if (searchCloseBtn) {
      searchCloseBtn.addEventListener('click', closeSearch);
    }
    doc.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && searchToggle.hasAttribute('open')) {
        closeSearch();
      }
    });
  }

  /* ------------------------------------------------------------------
     Localization selects auto-submit
  ------------------------------------------------------------------ */
  qsa('[data-auto-submit]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) {
        form.submit();
      }
    });
  });

  /* ------------------------------------------------------------------
     Sort select on collection pages
  ------------------------------------------------------------------ */
  qsa('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      try {
        var url = new URL(window.location.href);
        if (select.value) {
          url.searchParams.set('sort_by', select.value);
        } else {
          url.searchParams.delete('sort_by');
        }
        window.location.href = url.toString();
      } catch (e) {
        window.location.href = window.location.pathname + '?sort_by=' + encodeURIComponent(select.value);
      }
    });
  });

  /* ------------------------------------------------------------------
     Quantity steppers
  ------------------------------------------------------------------ */
  qsa('[data-quantity]').forEach(function (widget) {
    var input = qs('[data-qty-input]', widget);
    var minus = qs('[data-qty-minus]', widget);
    var plus = qs('[data-qty-plus]', widget);
    if (!input) {
      return;
    }

    var changeQty = function (delta) {
      var current = parseInt(input.value, 10) || 1;
      var next = Math.max(delta < 0 ? 1 : 1, current + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };

    if (minus) {
      minus.addEventListener('click', function () { changeQty(-1); });
    }
    if (plus) {
      plus.addEventListener('click', function () { changeQty(1); });
    }
  });

  /* ------------------------------------------------------------------
     Cart page: quantity changes, remove, totals
  ------------------------------------------------------------------ */
  var cartPage = qs('[data-cart-page]');
  if (cartPage) {
    if (/(?:^|[?&])checkout=1(?:&|$)/.test(window.location.search)) {
      var payBtn = qs('[name="checkout"]', cartPage);
      if (payBtn) {
        window.setTimeout(function () {
          payBtn.click();
        }, 80);
      }
    }
    var refreshCartCount = function (cart) {
      var count = cart.item_count || 0;
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    };

    var cartChangeUrl = function () {
      var url = SAMATRIP.routes.cartChange || '/cart/change';
      if (url.slice(-3) !== '.js') {
        url += '.js';
      }
      return url;
    };

    var updateCart = function (line, quantity) {
      var payload = {
        quantity: Number(quantity)
      };
      var row = qs('.cart-item[data-line="' + line + '"]');
      var key = row ? row.getAttribute('data-key') : '';
      if (key) {
        payload.id = key;
      } else {
        payload.line = Number(line);
      }
      return fetchJSON(cartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (cart) {
        refreshCartCount(cart);
        if (Number(quantity) === 0 || !cart.item_count) {
          window.location.reload();
          return;
        }
        if (row) {
          var index = parseInt(line, 10) - 1;
          var item = cart.items[index];
          if (item) {
            var total = qs('[data-line-total]', row);
            if (total) {
              total.textContent = formatMoney(item.line_price);
            }
            var input = qs('[data-qty-input]', row);
            if (input) {
              input.value = item.quantity;
            }
          }
        }
        var subtotal = qs('[data-cart-subtotal]');
        if (subtotal) {
          subtotal.textContent = formatMoney(cart.total_price);
        }
      }).catch(function () {
        window.location.reload();
      });
    };

    qsa('[data-qty-input]', cartPage).forEach(function (input) {
      var onQtyChange = function () {
        var line = input.getAttribute('data-line');
        var quantity = parseInt(input.value, 10);
        if (isNaN(quantity) || quantity < 0) {
          quantity = 0;
        }
        if (quantity === 0) {
          quantity = 0;
        }
        updateCart(line, quantity);
      };
      input.addEventListener('change', onQtyChange);
    });

    qsa('[data-qty-minus], [data-qty-plus]', cartPage).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.getAttribute('data-line');
        var input = qs('[data-qty-input][data-line="' + line + '"]');
        if (!input) {
          return;
        }
        var current = parseInt(input.value, 10) || 1;
        var next = btn.hasAttribute('data-qty-plus') ? current + 1 : current - 1;
        if (next < 0) {
          next = 0;
        }
        input.value = next;
        updateCart(line, next);
      });
    });

    qsa('[data-remove]', cartPage).forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var line = link.closest('.cart-item');
        var index = line ? line.getAttribute('data-line') : null;
        if (index) {
          updateCart(index, 0);
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Cart count refresh on all pages
  ------------------------------------------------------------------ */
  if (qs('[data-cart-count]')) {
    fetchJSON(SAMATRIP.routes.cart).then(function (cart) {
      qsa('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count || 0;
      });
    }).catch(function () { /* ignore */ });
  }

  /* ------------------------------------------------------------------
     Toast
  ------------------------------------------------------------------ */
  var toastTimer = null;
  function showToast(message, href) {
    var toast = qs('[data-toast]');
    if (!toast) {
      toast = doc.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('data-toast', '');
      toast.setAttribute('role', 'status');
      doc.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var text = doc.createElement('span');
    text.textContent = message;
    toast.appendChild(text);
    if (href) {
      var link = doc.createElement('a');
      link.href = href;
      link.textContent = 'Voir le panier';
      toast.appendChild(link);
    }
    toast.classList.add('is-visible');
    if (toastTimer) {
      clearTimeout(toastTimer);
    }
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3500);
  }

  /* ------------------------------------------------------------------
     Add to cart (product page)
  ------------------------------------------------------------------ */
  qsa('[data-product-form] form.product-form').forEach(function (form) {
    var submitBtn = qs('[data-add-to-cart]', form);
    if (!submitBtn) {
      return;
    }
    var productFormWrapper = form.closest('[data-product-form]');
    var liveContainer = qs('[data-booking-live]', form);
    var liveButton = qs('[data-live-check]', form);
    var liveStatus = qs('[data-live-status]', form);
    var liveReferenceInput = qs('[data-live-reference]', form);
    var liveEndpoint = productFormWrapper ? productFormWrapper.getAttribute('data-live-endpoint') : '';
    var liveDefaultEndpoint = productFormWrapper ? productFormWrapper.getAttribute('data-live-default-endpoint') : '';
    var liveSandboxEnabled = productFormWrapper
      ? productFormWrapper.getAttribute('data-live-sandbox-enabled') === 'true'
      : false;
    var liveProductCode = productFormWrapper ? productFormWrapper.getAttribute('data-live-product-code') : '';
    var resolvedLiveEndpoint = liveEndpoint || liveDefaultEndpoint;

    var departInput = qs('[data-booking-depart]', form);
    var returnInput = qs('[data-booking-return]', form);
    var syncBookingDates = function () {
      if (!departInput || !returnInput) {
        return;
      }
      if (departInput.value) {
        returnInput.min = departInput.value;
      } else {
        returnInput.removeAttribute('min');
      }
      if (returnInput.value && departInput.value && returnInput.value < departInput.value) {
        returnInput.value = departInput.value;
      }
    };
    if (departInput && returnInput) {
      departInput.addEventListener('change', syncBookingDates);
      returnInput.addEventListener('change', syncBookingDates);
      syncBookingDates();
    }

    if (liveContainer && liveButton && liveStatus) {
      liveButton.addEventListener('click', function () {
        if (liveButton.disabled) {
          return;
        }
        if (!resolvedLiveEndpoint) {
          liveStatus.classList.remove('is-ok');
          liveStatus.classList.add('is-error');
          liveStatus.textContent = 'Endpoint live non configuré.';
          return;
        }

        var bookingType = liveContainer.getAttribute('data-booking-type') || '';
        var bookingTypeField = qs('[name="properties[Type de réservation]"]', form);
        if (bookingType === 'flexible' && bookingTypeField && bookingTypeField.value) {
          bookingType = String(bookingTypeField.value).toLowerCase().indexOf('vol') !== -1 ? 'flight' : 'stay';
        }
        var payload = {
          bookingType: bookingType,
          productCode: liveProductCode || '',
          productId: productFormWrapper ? (productFormWrapper.getAttribute('data-product-id') || '') : '',
          variantId: (qs('[name="id"]', form) || {}).value || '',
          sandbox: liveSandboxEnabled
        };

        var formData = new FormData(form);
        payload.request = {};
        formData.forEach(function (value, key) {
          if (key.indexOf('properties[') === 0 && key.indexOf(']') > 10) {
            var cleanKey = key.slice(11, -1);
            payload.request[cleanKey] = value;
          }
        });

        liveButton.disabled = true;
        liveStatus.classList.remove('is-ok', 'is-error');
        liveStatus.textContent = 'Vérification en cours...';

        fetch(resolvedLiveEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(function (response) {
          if (!response.ok) {
            throw new Error('Service indisponible');
          }
          return response.json();
        }).then(function (result) {
          var isAvailable = !!(result && result.available);
          var message = (result && result.message) ? result.message : (isAvailable ? 'Disponible immédiatement.' : 'Indisponible actuellement.');
          if (result && result.mode === 'sandbox') {
            message += ' (sandbox)';
          }
          liveStatus.textContent = message;
          liveStatus.classList.toggle('is-ok', isAvailable);
          liveStatus.classList.toggle('is-error', !isAvailable);

          if (liveReferenceInput) {
            liveReferenceInput.value = (result && result.reference) ? result.reference : '';
          }

          if (isAvailable && typeof result.price_cents === 'number') {
            var priceEl = qs('[data-product-price]');
            if (priceEl) {
              priceEl.textContent = formatMoney(result.price_cents);
            }
          }
        }).catch(function (err) {
          liveStatus.classList.remove('is-ok');
          liveStatus.classList.add('is-error');
          liveStatus.textContent = (err && err.message) ? err.message : 'Erreur lors de la vérification live.';
        }).finally(function () {
          liveButton.disabled = false;
        });
      });
    }

    form.addEventListener('submit', function (event) {
      if (departInput && returnInput && departInput.value && returnInput.value && returnInput.value < departInput.value) {
        event.preventDefault();
        showToast('La date de retour doit être après la date de départ.');
        return;
      }
      event.preventDefault();
      if (submitBtn.disabled) {
        return;
      }
      submitBtn.disabled = true;

      var data = new FormData(form);
      fetchJSON(SAMATRIP.routes.cartAdd, {
        method: 'POST',
        body: data
      }).then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count || 0;
        });
        showToast('Package ajouté au panier !', SAMATRIP.routes.cart);
        submitBtn.disabled = false;
      }).catch(function (err) {
        var message = (err && err.message) ? err.message : 'Une erreur est survenue. Réessayez.';
        showToast(message);
        submitBtn.disabled = false;
      });
    });
  });

  /* ------------------------------------------------------------------
     Product variants
  ------------------------------------------------------------------ */
  var productFormWrapper = qs('[data-product-form][data-product-json-id]');
  if (productFormWrapper) {
    var productForm = qs('form.product-form', productFormWrapper);
    var variantSelect = qs('[name="id"]', productFormWrapper);
    var variantsJsonEl = qs('#' + productFormWrapper.getAttribute('data-product-json-id'));
    var variants = [];

    try {
      variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : [];
    } catch (e) {
      variants = [];
    }

    var priceEl = qs('[data-product-price]');
    var compareEl = qs('[data-product-compare]');
    var mainImage = qs('#GalleryMain');
    var optionSelectedLabels = qsa('[data-option-selected]');

    var selectVariant = function () {
      var pills = qsa('.option-pill.is-active', productFormWrapper);
      if (pills.length !== (productForm.querySelectorAll('.product-option').length || 0) && productForm.querySelectorAll('.product-option').length > 0) {
        return;
      }
      var selectedValues = pills.map(function (p) { return p.getAttribute('data-value'); });
      var match = null;

      variants.forEach(function (variant) {
        var allMatch = variant.options.every(function (value, index) {
          return String(value).toLowerCase() === String(selectedValues[index]).toLowerCase();
        });
        if (allMatch) {
          match = variant;
        }
      });

      if (!match) {
        return;
      }

      if (variantSelect) {
        variantSelect.value = match.id;
      }

      if (priceEl && match.price) {
        priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          if (match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      }

      if (mainImage && match.featured_image && match.featured_image.id) {
        var thumb = qs('.gallery__thumb[data-thumb="' + match.featured_image.id + '"]');
        if (thumb) {
          var img = qs('img', thumb);
          if (img) {
            mainImage.src = img.src;
            mainImage.alt = img.alt;
          }
        }
      }

      if (optionSelectedLabels && optionSelectedLabels.length) {
        var optionIndex = 0;
        qsa('.product-option', productFormWrapper).forEach(function (optionEl, idx) {
          var label = qs('[data-option-selected]', optionEl);
          if (label && selectedValues[idx]) {
            label.textContent = selectedValues[idx];
          }
        });
      }

      var submitBtn = qs('[data-add-to-cart]', productFormWrapper);
      if (submitBtn) {
        submitBtn.disabled = false;
        var text = qs('[data-add-to-cart-text]', submitBtn);
        if (text) {
          text.textContent = 'Ajouter au panier';
        }
      }
    };

    qsa('.option-pill', productFormWrapper).forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.product-option');
        if (group) {
          qsa('.option-pill', group).forEach(function (p) {
            p.classList.remove('is-active');
          });
        }
        pill.classList.add('is-active');
        selectVariant();
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var id = variantSelect.value;
        variants.forEach(function (variant) {
          if (String(variant.id) === String(id)) {
            variant.options.forEach(function (value, index) {
              var group = qsa('.product-option', productFormWrapper)[index];
              if (group) {
                qsa('.option-pill', group).forEach(function (p) {
                  p.classList.toggle('is-active', p.getAttribute('data-value') === String(value));
                });
              }
            });
            if (priceEl && variant.price) {
              priceEl.textContent = formatMoney(variant.price);
            }
            if (mainImage && variant.featured_image && variant.featured_image.id) {
              var thumb = qs('.gallery__thumb[data-thumb="' + variant.featured_image.id + '"]');
              if (thumb) {
                var img = qs('img', thumb);
                if (img) {
                  mainImage.src = img.src;
                }
              }
            }
          }
        });
      });
    }
  }

  /* ------------------------------------------------------------------
     Gallery thumbnails
  ------------------------------------------------------------------ */
  qsa('.gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var img = qs('img', thumb);
      var main = qs('#GalleryMain');
      if (img && main) {
        main.src = img.src;
        main.alt = img.alt;
      }
      qsa('.gallery__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  /* ------------------------------------------------------------------
     Favorites (localStorage)
  ------------------------------------------------------------------ */
  var FAV_KEY = 'samatrip:favorites';
  var favorites = [];
  try {
    favorites = JSON.parse(localStorage.getItem(FAV_KEY)) || [];
  } catch (e) {
    favorites = [];
  }

  qsa('[data-fav]').forEach(function (btn) {
    var key = btn.closest('a') ? btn.closest('a').getAttribute('href') : btn.getAttribute('data-key');
    if (!key) {
      key = 'fav-' + Math.random().toString(36).slice(2);
      btn.setAttribute('data-key', key);
    }
    if (favorites.indexOf(key) !== -1) {
      btn.classList.add('is-fav');
    }
    btn.addEventListener('click', function () {
      var index = favorites.indexOf(key);
      if (index === -1) {
        favorites.push(key);
        btn.classList.add('is-fav');
      } else {
        favorites.splice(index, 1);
        btn.classList.remove('is-fav');
      }
      try {
        localStorage.setItem(FAV_KEY, JSON.stringify(favorites));
      } catch (e) { /* ignore */ }
    });
  });

  /* ------------------------------------------------------------------
     Address forms (customer addresses page)
  ------------------------------------------------------------------ */
  var toggleAddressButtons = qsa('[data-toggle-address-form]');
  var addAddressBlock = qs('#AddAddress');
  if (toggleAddressButtons.length && addAddressBlock) {
    toggleAddressButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        addAddressBlock.hidden = !addAddressBlock.hidden;
      });
    });
  }

  qsa('[data-edit-address]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-address-id');
      var form = qs('[data-edit-form="' + id + '"]');
      if (form) {
        form.hidden = !form.hidden;
      }
    });
  });

  qsa('[data-cancel-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-address-id');
      var form = qs('[data-edit-form="' + id + '"]');
      if (form) {
        form.hidden = true;
      }
    });
  });

  /* ------------------------------------------------------------------
     Reveal on scroll
  ------------------------------------------------------------------ */
  var revealEls = qsa('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ------------------------------------------------------------------
     Language switcher
  ------------------------------------------------------------------ */
  qsa('[data-language-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (select.form) {
        select.form.submit();
      }
    });
    var form = select.form;
    if (!form) return;
    qsa('[data-locale]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        select.value = btn.getAttribute('data-locale');
        form.submit();
      });
    });
  });
})();
